var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 8.04126C0.970178 8.04126 1.25 8.32108 1.25 8.66626L1.25 11.8427C1.25 12.8133 2.03679 13.6001 3.00735 13.6001H11.7426C12.7132 13.6001 13.5 12.8133 13.5 11.8427V8.66626C13.5 8.32108 13.7798 8.04126 14.125 8.04126C14.4702 8.04126 14.75 8.32108 14.75 8.66626V11.8427C14.75 13.5036 13.4036 14.8501 11.7426 14.8501H3.00735C1.34644 14.8501 0 13.5036 0 11.8427L0 8.66626C0 8.32108 0.279822 8.04126 0.625 8.04126ZM7.37533 0.149414L7.78207 0.498052L10.9321 3.19805C11.1942 3.42269 11.2245 3.81725 10.9999 4.07933C10.7752 4.34141 10.3807 4.37176 10.1186 4.14712L8.00037 2.33151V7.94756C8.00037 8.29274 7.72054 8.57256 7.37537 8.57256C7.03019 8.57256 6.75037 8.29274 6.75037 7.94756L6.75037 2.33144L4.63207 4.14712C4.37 4.37176 3.97543 4.34141 3.75079 4.07933C3.52616 3.81725 3.55651 3.42269 3.81859 3.19805L6.96859 0.498052L7.37533 0.149414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5290c76e630bfe6a88dcde3936946978.svg";
export { ForwardRef as ReactComponent };